// 重要的事情说三遍！！！
// 不要随意修改模板的内容，需要修改务必复制一份到views文件夹再编辑！！！
// 不要随意修改模板的内容，需要修改务必复制一份到views文件夹再编辑！！！
// 不要随意修改模板的内容，需要修改务必复制一份到views文件夹再编辑！！！

// 所有表格行相同的配置
const columnPublicConfig = {
    align: 'center'
}

// 筛选器配置
const filterItemsConfig = {
    scopedSlots: {
        filterDropdown: 'filterDropdown',
        filterIcon: 'filterIcon'
    }
}

// 编辑内容配置
export const formModel = {
    username: '',
    password: ''
}

// 表格配置
/**
 * title: 表格标题
 * dataIndex: 后端返回的这个标题的名字
 * filterIndex: 筛选器字段，一般和dataIndex一样，如果是选择型的筛选器，这里填写id字段
 * key: 随便选择dataIndex或filterIndex中的一个
 * type: 筛选器类型，input = 输入框，select = 选择框
 * multi: 如果选择型筛选器需要多选，就写上值为true
 * items: 选择型筛选器必须带上这个，默认为空数组
 */
export const columns = [{
    title: '客户姓名',
    dataIndex: 'name',
    filterIndex: 'name',
    key: 'name',
    type: 'input',
    ...columnPublicConfig,
    ...filterItemsConfig
},
{
    title: '联系人',
    dataIndex: 'contact',
    filterIndex: 'contact',
    key: 'contact',
    type: 'input',
    ...columnPublicConfig,
    ...filterItemsConfig
},
{
    title: '手机号码',
    dataIndex: 'mobile',
    filterIndex: 'mobile',
    key: 'mobile',
    type: 'input',
    ...columnPublicConfig,
    ...filterItemsConfig
},
{
    title: '客户地址',
    dataIndex: 'address',
    key: 'address',
    ...columnPublicConfig
},
{
    title: '所属区域',
    dataIndex: 'areaname',
    key: 'areaname',
    width: 115,
    ...columnPublicConfig
},
{
    title: '所属气站',
    dataIndex: 'status',
    key: 'status',
    ...columnPublicConfig
},
{
    title: '所属门店',
    dataIndex: 'shop',
    key: 'shop',
    ...columnPublicConfig
},
{
    title: '优惠价格',
    dataIndex: 'money',
    key: 'money',
    ...columnPublicConfig
},
{
    title: '客户类型',
    dataIndex: 'typename',
    filterIndex: 'ctyid',
    key: 'typename',
    type: 'select',
    items: [],
    ...columnPublicConfig,
    ...filterItemsConfig
},
{
    title: '是否常用',
    dataIndex: 'type',
    filterIndex: 'type',
    key: 'type',
    type: 'select',
    items: [{
        id: 1,
        name: '是'
    }, {
        id: 2,
        name: '否'
    }],
    scopedSlots: {
        customRender: 'c-type',
        ...filterItemsConfig.scopedSlots
    },
    ...columnPublicConfig
},
{
    title: '操作',
    dataIndex: 'action',
    key: 'action',
    scopedSlots: {
        customRender: 'c-action'
    }
}]
